module.exports = __webpack_public_path__ + "img/bullying-background.55bf2241.png";